import { ALL_AUTHORS } from '../constants/manage/AuthorConstants';
import { ARCHIVED_FIELD, AUTHOR_FIELD, KNOWLEDGE_CATEGORY_FIELD, ORDER_FIELD, SEARCH_FIELD, STATE_FIELD, VISIBILITY_FIELD, VISIBILITY_LISTS_FIELD, VISIBILITY_TYPE_FIELD } from '../constants/manage/LegacyArticleQueryConstants';
import TableConstants from '../constants/manage/TableConstants';
import { publicAccessRuleTypeOrdinals, visibilityOptions } from '../constants/ArticleVisibilityConstants';
import StateConstants from '../constants/StateConstants';
import LegacyArticlesQuery from '../records/manage/LegacyArticlesQueryRecord';
const setVisibility = (query, visibility) => {
  switch (visibility) {
    case visibilityOptions.ALL_AUDIENCE:
      {
        return query.delete(VISIBILITY_FIELD).delete(VISIBILITY_LISTS_FIELD);
      }
    case visibilityOptions.PUBLIC:
      {
        return query.set(VISIBILITY_FIELD, false);
      }
    case visibilityOptions.NOT_PUBLIC:
      {
        return query.set(VISIBILITY_FIELD, true).set(VISIBILITY_TYPE_FIELD, [publicAccessRuleTypeOrdinals.LIST_MEMBERSHIP, publicAccessRuleTypeOrdinals.SSO_LOGIN, publicAccessRuleTypeOrdinals.ACCESS_GROUP_MEMBERSHIP]);
      }
    case visibilityOptions.RESTRICTED:
    case visibilityOptions.SSO_WITH_SPECIFIC_CONTACTS:
      {
        return query.set(VISIBILITY_FIELD, true).set(VISIBILITY_TYPE_FIELD, publicAccessRuleTypeOrdinals.LIST_MEMBERSHIP);
      }
    case visibilityOptions.ACCESS_GROUP_MEMBERSHIP:
    case visibilityOptions.SSO_WITH_ACCESS_GROUPS:
      {
        return query.set(VISIBILITY_FIELD, true).set(VISIBILITY_TYPE_FIELD, publicAccessRuleTypeOrdinals.ACCESS_GROUP_MEMBERSHIP);
      }
    case visibilityOptions.SSO:
      {
        return query.set(VISIBILITY_FIELD, true).delete(VISIBILITY_LISTS_FIELD).set(VISIBILITY_TYPE_FIELD, publicAccessRuleTypeOrdinals.SSO_LOGIN);
      }
    default:
      return query.merge({
        [VISIBILITY_FIELD]: true,
        [VISIBILITY_LISTS_FIELD]: visibility,
        [VISIBILITY_TYPE_FIELD]: publicAccessRuleTypeOrdinals.LIST_MEMBERSHIP
      });
  }
};
const setState = (query, articleState) => {
  switch (articleState) {
    case StateConstants.ARCHIVED:
      return query.set(ARCHIVED_FIELD, true).set(STATE_FIELD, null);
    case StateConstants.DRAFT:
    case StateConstants.PUBLISHED:
      return query.set(ARCHIVED_FIELD, false).set(STATE_FIELD, articleState);
    case StateConstants.DEFAULT:
    default:
      return query.set(ARCHIVED_FIELD, false).set(STATE_FIELD, null);
  }
};
const setOrder = (query, sortColumn, sortDir) => {
  if (sortColumn && (sortDir === TableConstants.DESC_ORDER || sortDir === TableConstants.ASC_ORDER)) {
    const order = `${sortDir === TableConstants.DESC_ORDER ? '-' : ''}${sortColumn}`;
    return query.set(ORDER_FIELD, order);
  }
  return query;
};
export function getLegacyArticlesQuery(filterParams, articleState = StateConstants.DEFAULT, knowledgeBaseId) {
  const {
    authorId,
    categoryIds,
    searchTerm,
    sortColumn,
    sortDir,
    visibility
  } = filterParams;
  let query = new LegacyArticlesQuery(filterParams);
  if (authorId && authorId !== ALL_AUTHORS) {
    query = query.set(AUTHOR_FIELD, authorId);
  }
  if (categoryIds && categoryIds.count() > 0) {
    query = query.set(KNOWLEDGE_CATEGORY_FIELD, categoryIds.toJS());
  }
  if (searchTerm && searchTerm.trim().length > 0) {
    query = query.set(SEARCH_FIELD, searchTerm.trim());
  }
  query = setVisibility(query, visibility);
  query = setState(query, articleState);
  query = setOrder(query, sortColumn, sortDir);
  query = query.set('contentGroupId', typeof knowledgeBaseId === 'number' ? `${knowledgeBaseId}` : knowledgeBaseId);
  query = query.set('knowledgeBaseId', typeof knowledgeBaseId === 'string' ? parseInt(knowledgeBaseId, 10) : knowledgeBaseId);
  return query;
}